/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PreferredLanguageEnum,
	PreferredLanguageEnumFromJSON,
	PreferredLanguageEnumFromJSONTyped,
	PreferredLanguageEnumToJSON,
} from "./PreferredLanguageEnum";

/**
 *
 * @export
 * @interface CompanyUpdateAdminDTO
 */
export interface CompanyUpdateAdminDTO {
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	commercialName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	name?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	cui?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	emailContact?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	address?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	postalCode?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	city?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	country?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	phone?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	domainOfActivity?: string | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof CompanyUpdateAdminDTO
	 */
	areasOfInterest?: Array<string> | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	siteUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	linkedInUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	description?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	lowResImage?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	fullResImage?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CompanyUpdateAdminDTO
	 */
	fax?: string | null;
	/**
	 *
	 * @type {PreferredLanguageEnum}
	 * @memberof CompanyUpdateAdminDTO
	 */
	preferredLanguage?: PreferredLanguageEnum;
}

export function CompanyUpdateAdminDTOFromJSON(
	json: any
): CompanyUpdateAdminDTO {
	return CompanyUpdateAdminDTOFromJSONTyped(json, false);
}

export function CompanyUpdateAdminDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyUpdateAdminDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		commercialName: !exists(json, "commercialName")
			? undefined
			: json["commercialName"],
		name: !exists(json, "name") ? undefined : json["name"],
		cui: !exists(json, "cui") ? undefined : json["cui"],
		emailContact: !exists(json, "emailContact")
			? undefined
			: json["emailContact"],
		address: !exists(json, "address") ? undefined : json["address"],
		postalCode: !exists(json, "postalCode") ? undefined : json["postalCode"],
		city: !exists(json, "city") ? undefined : json["city"],
		country: !exists(json, "country") ? undefined : json["country"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
		domainOfActivity: !exists(json, "domainOfActivity")
			? undefined
			: json["domainOfActivity"],
		areasOfInterest: !exists(json, "areasOfInterest")
			? undefined
			: json["areasOfInterest"],
		siteUrl: !exists(json, "siteUrl") ? undefined : json["siteUrl"],
		linkedInUrl: !exists(json, "linkedInUrl") ? undefined : json["linkedInUrl"],
		description: !exists(json, "description") ? undefined : json["description"],
		lowResImage: !exists(json, "lowResImage") ? undefined : json["lowResImage"],
		fullResImage: !exists(json, "fullResImage")
			? undefined
			: json["fullResImage"],
		fax: !exists(json, "fax") ? undefined : json["fax"],
		preferredLanguage: !exists(json, "preferredLanguage")
			? undefined
			: PreferredLanguageEnumFromJSON(json["preferredLanguage"]),
	};
}

export function CompanyUpdateAdminDTOToJSON(
	value?: CompanyUpdateAdminDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		commercialName: value.commercialName,
		name: value.name,
		cui: value.cui,
		emailContact: value.emailContact,
		address: value.address,
		postalCode: value.postalCode,
		city: value.city,
		country: value.country,
		phone: value.phone,
		domainOfActivity: value.domainOfActivity,
		areasOfInterest: value.areasOfInterest,
		siteUrl: value.siteUrl,
		linkedInUrl: value.linkedInUrl,
		description: value.description,
		lowResImage: value.lowResImage,
		fullResImage: value.fullResImage,
		fax: value.fax,
		preferredLanguage: PreferredLanguageEnumToJSON(value.preferredLanguage),
	};
}
